import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import zhCNLang from '../../../../public/locales/snackMachine/zh_CN.json';

// 初始化语言
const initLanguage = () => {
  try {
    const DEFAULT = JSON.parse(new Buffer(window._i18n_, 'base64')).default;
    const DEFAULT_LNG = DEFAULT.lang; // 需要的语言
    const DEFAULT_DICT = DEFAULT.locale; // 需要的语言的语言包
    // const DEFAULT_FALLBACK_LANG = DEFAULT.fallbackLng; // 默认的语言
    i18next.use(initReactI18next).init({
      lng: DEFAULT_LNG,
      // fallbackLng: DEFAULT_FALLBACK_LANG,
      resources: {
        [DEFAULT_LNG]: {
          translation: DEFAULT_DICT
        }
      },
      debug: true
    });
  } catch (error) {
    // console.log(zhCNLang);
    // 异常 默认本地语言包
    const language = {
      lang: 'zh_CN',
      locale: zhCNLang,
      fallbackLng: 'zh_CN'
    };
    const DEFAULT_LNG = language.lang;
    const DEFAULT_DICT = language.locale || {};
    // const DEFAULT_FALLBACK_LANG = language.fallbackLng;
    i18next.use(initReactI18next).init({
      lng: DEFAULT_LNG,
      // fallbackLng: DEFAULT_FALLBACK_LANG,
      resources: {
        [DEFAULT_LNG]: {
          translation: DEFAULT_DICT
        }
      },
      debug: true
    });
  }
};

// 变更语言
const changeLang = (lang) => {
  if (!i18next.hasResourceBundle(lang, 'translation')) {
    const origin = window.location.origin.replace('3000', '8080');
    const fetchLangUrl = `${origin}/luckin-i18n/${lang}`;
    global
      .fetch(fetchLangUrl)
      .then((res) => res.json())
      .then((langRes) => {
        i18next.addResourceBundle(
          lang,
          'translation',
          langRes.locale,
          true,
          true
        );
        i18next.changeLanguage(lang);
      });
  } else {
    i18next.changeLanguage(lang);
  }
};

// 初始化语言包
initLanguage();

export { changeLang };
export default i18next;
